var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',_vm._l((_vm.likeList),function(item){return _c('div',{key:item.key,staticClass:"page-likes-mask",style:({'top': item.likesTop, 'left': item.likesLeft})},[_c('div',{staticClass:"heart heartAnimation"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }